import { Button } from "@/components/elements/Button";
import { Stack, styled } from "@mui/material";
import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@/hooks/useMediaQuery";

type TFooterActionBarProps = {
  title: string;
  backUrl?: string;
  isHideButtonSubmit?: boolean;
  onSubmit?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  children?: ReactNode;
};

export const FooterActionBar: FC<TFooterActionBarProps> = ({
  title,
  onSubmit,
  backUrl,
  isLoading,
  isDisabled,
  isHideButtonSubmit = false,
  children,
}) => {
  const { isLaptop } = useMediaQuery();

  return (
    <FooterContainer isLaptop={isLaptop}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Stack direction="row" gap={1} alignItems="center">
          {backUrl && (
            <ButtonFooter variant="secondary" component={Link} to={backUrl} isLoading={false}>
              戻る
            </ButtonFooter>
          )}
        </Stack>

        <Stack direction="row" gap={3} alignItems="center">
          {children}
          {!isHideButtonSubmit && (
            <ButtonFooter variant="primary" onClick={onSubmit} isLoading={isLoading} disabled={isDisabled}>
              {title}
            </ButtonFooter>
          )}
        </Stack>
      </Stack>
    </FooterContainer>
  );
};

const FooterContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "isLaptop",
})<{ isLaptop: boolean }>`
  position: fixed;
  bottom: 32px;
  left: ${({ isLaptop }) => (!isLaptop ? "266px" : "24px")};
  right: 24px;
  padding: 24px;
  border-top: 1px solid #e6e7e8;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 #00000026;
  z-index: 1;
  height: 85px;
`;

const ButtonFooter = styled(Button)`
  height: 37px;
  min-width: 60px;
  opacity: 1;
  border-width: 2px;
  gap: 8px;
  padding: 0 22px;
`;
